import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';
import language from "@lang/language";

const PriceF = ({priceData, color = ''}) => {

	return (
	  <div className={`${styles.PriceF} ${color ? styles[color] : ''}`}>
		  <div className={styles.row}>
			  {/*///////////////////////////////////*/}
			  {/*NORMAL ELEMENT*/}
			  {/*<div className={`${styles.cell} ${styles.firstCell} uppercase`}>*/}
			  {/*  .{priceData.serviceName}*/}
			  {/*</div>*/}
			  {/*///////////////////////////////////*/}

			  {/*///////////////////////////////////*/}
			  {/*ELEMENT WITH TAG*/}
			  <div className={`${styles.cell} ${styles.firstCell} ${styles.withTag} uppercase`}>
				  <div>.{priceData.serviceName}</div>
				  {(priceData.serviceName === 'eu' || priceData.serviceName === 'bg') &&
					<div className={styles.tag}>{language.promoPrice}</div>
				  }
			  </div>
			  {/*///////////////////////////////////*/}

			  <div className={`${styles.cell} ${styles.prcHolder}`}>
				  <div className={styles.prcColumn}>
					  <span>{priceData.price}</span>
					  <span className={styles.currency}>{language.eurY}</span>
				  </div>
				  <span className={styles.oldPrc}>{priceData.basePrice} {language.eurY}</span>
			  </div>
		  </div>
	  </div>
	);
}

PriceF.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceF;
